<template>
  <base-modal
    :modal-title="$t('addConfiguration')"
    :dialog-visible="modelValue"
    :confirm-text="$t('save')"
    width="400px"
    @close="close"
    @confirm="confirm"
  >
    <template #content>
      <el-form
        ref="formRef"
        :model="form"
        :rules="formRules"
        label-position="top"
        @submit.prevent="confirm"
      >
        <el-form-item :label="$t('newBrokerSftpDescription')" prop="name">
          <el-input v-model="form.name" size="small" />
        </el-form-item>
      </el-form>
    </template>
  </base-modal>
</template>
<script lang="ts">
import BaseModal from '@/components/modals/BaseModal.vue';
import { ElForm, ElFormItem, ElInput } from 'element-plus';
import { reactive, ref } from 'vue';
import i18n from '@/i18n';

export default {
  name: 'NewBrokerSftpConfigurationModal',
  components: {
    BaseModal,
    ElInput,
    ElForm,
    ElFormItem
  },
  props: {
    modelValue: { type: Boolean, default: false },
    existingNames: {
      type: Array as () => Array<string>,
      default: () => new Array<string>()
    }
  },
  emits: ['close', 'confirm'],
  setup(props, { emit }) {
    const localMustNotBeInArray = (rule: any, value: string, callback: any) => {
      if (
        props.existingNames.some(
          el => el.toLocaleLowerCase() == value.toLocaleLowerCase()
        )
      ) {
        callback(
          new Error(i18n.global.t('brokerSftpWithThisNameAlreadyExists'))
        );
      } else callback();
    };

    const form = reactive({
      name: ''
    });
    const formRef = ref<HTMLFormElement>();
    const formRules = reactive({
      name: [
        {
          required: true,
          message: i18n.global.t('thisFieldIsRequired'),
          trigger: 'blur'
        },
        {
          min: 3,
          message: i18n.global
            .t('pleaseEnterNumCharacters')
            .replace('[num]', '3'),
          trigger: 'blur'
        },
        {
          validator: localMustNotBeInArray,
          triegger: 'blur'
        }
      ]
    });

    const confirm = () => {
      formRef.value?.validate((valid: boolean) => {
        if (valid) {
          emit('confirm', form.name);
        }
      });
    };
    const close = () => {
      emit('close');
    };

    return {
      form,
      formRules,
      formRef,
      confirm,
      close
    };
  }
};
</script>
